import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const MINIMAL_AUTH_PATHS = ['/login', '/forgot-password', '/resetpassword']

function isMinimalAuthPath(pathname) {
  const path = (pathname || '').toLowerCase()
  if (MINIMAL_AUTH_PATHS.some(route => path === route)) return true
  return path.startsWith('/login/')
}

export default function ThemeLoader() {
  const location = useLocation()
  const themeLoaded = useRef(false)
  const i18nLoaded = useRef(false)

  useEffect(() => {
    if (isMinimalAuthPath(location.pathname)) return

    if (!i18nLoaded.current) {
      i18nLoaded.current = true
      import('../../i18n')
    }

    if (themeLoaded.current) return

    themeLoaded.current = true
    import('../../setup/primeReactStyles')
    import('../../assets/scss/theme.scss')
  }, [location.pathname])

  return null
}
